var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Envelope\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0815 3.49026C12.1753 3.4157 12.3148 3.48545 12.3148 3.60331V8.522C12.3148 9.15939 11.7977 9.67651 11.1603 9.67651H1.15451C0.517124 9.67651 0 9.15939 0 8.522V3.60571C0 3.48545 0.137098 3.4181 0.233307 3.49267C0.772079 3.91118 1.48643 4.44273 3.93977 6.22501C4.44727 6.59541 5.30353 7.37471 6.15739 7.3699C7.01606 7.37711 7.88915 6.58098 8.37742 6.22501C10.8308 4.44273 11.5427 3.90877 12.0815 3.49026ZM6.15739 6.59782C6.7154 6.60744 7.51875 5.89549 7.92283 5.60205C11.1146 3.28582 11.3575 3.08378 12.0935 2.50652C12.233 2.39829 12.3148 2.22992 12.3148 2.05193V1.59494C12.3148 0.957554 11.7977 0.44043 11.1603 0.44043H1.15451C0.517124 0.44043 0 0.957554 0 1.59494V2.05193C0 2.22992 0.0817778 2.39588 0.221281 2.50652C0.957282 3.08137 1.20021 3.28582 4.39195 5.60205C4.79603 5.89549 5.59938 6.60744 6.15739 6.59782Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.585f6e6c261f068a17231fde13aea7f8.svg";
export { ForwardRef as ReactComponent };